import { getBaseurl } from './routes';

const ENDPOINTS = Object.freeze({
  login: getBaseurl('v1/auth/clientLogin'),
  otp: getBaseurl('v1/auth/otp'),
  otpSend: getBaseurl('v1/auth/sendOtp'),
  otpResend: getBaseurl('v1/auth/resendOtp'),
  retrieval: getBaseurl('v1/offer/calculateForKnownPeriodAndRiskById'),
  offer: getBaseurl('v1/offer/getById'),
  createUpdate: getBaseurl('v1/offer/createOrUpdate'),
  createProfile: getBaseurl('v1/payment/createLowProfile'),
  finish: getBaseurl('v1/offer/finishProcess'),
  fileGet: getBaseurl('v1/offer/getSummeryFile'),
  counselorList: getBaseurl('v1/counselor/list'),
  meetingSlots: getBaseurl('v1/meeting/availableSlots'),
  meetingCreate: getBaseurl('v1/meeting/book'),
  locales: getBaseurl('v1/locales/he.json'),
  approveTermsOfUse: getBaseurl('v1/client/approveTerms'),
  getClientById: getBaseurl('v1/client/getById'),
  leadCreate: getBaseurl('v1/lead/create'),
});

export {
  ENDPOINTS,
};
